'use strict';

angular.module('licensure.services')
    .factory('Countries', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/countries', {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/countries/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;